import React from 'react';
import {
  Row,
  Col,
} from 'reactstrap';
import FontAwesome from 'react-fontawesome';

export default function Footer() {
  const a = '';
  return (
    <Row>
      <Col className="footer" >
        <p className="mb-0">
          <small className="text-muted">
            made by Kyu❤️Gyu
            <br></br>
            버그문의: 신랑, 신부
          </small>
        </p>
      </Col>
    </Row>
  );
}
